// client/src/hooks/useComunicacaoAgendada.js
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';
import useAlert from './useAlert';

const COMUNICACAO_AGENDADA_QUERY_KEY = 'comunicacaoAgendada';

// 🔹 Buscar fila de comunicações agendadas (padrão: status=Pendente)
export const useComunicacoesAgendadas = (params, options) => {
    const { setAlert } = useAlert();

    return useQuery({
        queryKey: [COMUNICACAO_AGENDADA_QUERY_KEY, params],
        queryFn: async () => {
            try {
                const { data } = await api.get('/comunicacao-agendada', { params });
                return data.data;
            } catch (error) {
                setAlert(error.response?.data?.error || 'Erro ao carregar fila de comunicações', 'danger');
                throw error;
            }
        },
        placeholderData: (previousData) => previousData,
        ...options,
    });
};

// 🔹 Cancelar um item Pendente da fila
export const useCancelarComunicacaoAgendada = () => {
    const queryClient = useQueryClient();
    const { setAlert } = useAlert();

    return useMutation({
        mutationFn: async (id) => {
            const response = await api.patch(`/comunicacao-agendada/${id}/cancelar`);
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [COMUNICACAO_AGENDADA_QUERY_KEY] });
            setAlert('Envio agendado cancelado com sucesso.', 'success');
        },
        onError: (err) => {
            const msg = err.response?.data?.error || err.response?.data?.message || 'Erro ao cancelar envio agendado';
            setAlert(msg, 'danger');
        },
    });
};
